import { Form, Input, Typography } from 'antd'
import React from 'react'

const { Text } = Typography

const FormItem = ({ title, attribute, placeholder }) => {
  return (
    <>
    <Text strong>{title}</Text>
      <Form.Item name={attribute}>
       <Input placeholder={placeholder} />
      </Form.Item>
  </>
  )
}

export default FormItem
